import React from 'react';

import { InputAdornment, TableRow, TextField, Typography } from '@material-ui/core';

import { NoBorderCell } from 'components/common/table/TableStyle';
import { BoldText } from '../ModalContent.styled';
import { MAX_COUPON_RATE } from 'constants/member/connect';
import { CouponFormField } from 'types/member';

interface Props {
  couponRate: string;
  onChangeValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Rate = ({ couponRate, onChangeValue }: Props) => {
  return (
    <TableRow>
      <NoBorderCell>
        <BoldText>Discount Rate</BoldText>
      </NoBorderCell>
      <NoBorderCell
        style={{ display: 'flex', alignItems: 'center', gap: '8px', alignContent: 'left' }}
      >
        <TextField
          name={CouponFormField.RATE}
          type={'number'}
          size={'small'}
          variant={'outlined'}
          value={couponRate}
          onChange={onChangeValue}
          inputProps={{ max: MAX_COUPON_RATE }}
          style={{ minWidth: '202.5px' }}
        />
        <Typography variant="body2" style={{ fontSize: '12px', marginRight: '10px' }}>
          %
        </Typography>
        <Typography variant="body2" style={{ color: '#999', fontSize: '12px' }}>
          Up to {MAX_COUPON_RATE}% off
        </Typography>
      </NoBorderCell>
    </TableRow>
  );
};

export default Rate;
